import * as actions from '../utils/Constants';

export const spin = () => ({
    type: actions.SHOW_SPINNER
});

export const dontSpin = () => ({
    type: actions.HIDE_SPINNER
});